dmx.Component('datastore', {

    initialData: function() {
        return {
            data: []
        };
    },

    attributes: {
        session: {
            type: Boolean,
            default: false
        },

        columns: {
            type: Object,
            default: {}
        }
    },

    methods: {
        insert: function(data) {
            this._insert(data);
            this._store();
        },

        update: function(filter, data) {
            this._update(filter, data);
            this._store();
        },

        upsert: function(filter, data) {
            var toUpdate = this._filter(filter);
            if (toUpdate.length) {
                this._update(filter, data);
            } else {
                this._insert(data);
            }
            this._store();
        },

        delete: function(filter) {
            this._delete(filter);
            this._store();
        },

        clear: function() {
            this.records = [];
            this.lastid = 0;
            this._store();
        },

        get: function(filter) {
            return this._filter(filter);
        }
    },

    events: {
        inserted: Event,
        updated: Event,
        deleted: Event
    },

    render: function(node) {
        this.$node = null;
        this.store = window[this.props.session ? 'sessionStorage' : 'localStorage'];
        this.records = [];
        this.lastid = 0;

        try {
            var stored = this.store.getItem('datastore_' + this.name);
            if (stored) {
                stored = JSON.parse(stored);
                if (stored.records) this.records = stored.records;
                if (stored.lastid) this.lastid = stored.lastid;
            }
        } catch(err) {
            console.warn('Error parsing datastore', err);
        }

        //this.set('data', dmx.clone(this.records));
        this._setData();
    },

    update: function(props) {
        if (!dmx.equal(props.columns, this.props.columns)) {
            this._setData();
        }
    },

    _filter: function(filter) {
        if (typeof filter == 'number') filter = { $id: filter };

        return this.records.filter(function filterRecord(record) {
            if (Array.isArray(filter)) {
                for (var i = 0; i < filter.length; i++) {
                    for (var prop in filter[i]) {
                        if (record[prop] === filter[i][prop]) {
                            return true;
                        }
                    }
                }
            } else {
                for (var prop in filter) {
                    if (record[prop] === filter[prop]) {
                        return true;
                    }
                }
            }

            return false;
        });
    },

    _parseData: function(data) {
        if (typeof data == 'object' && !Array.isArray(data)) {
            return true;
        }

        return false;
    },

    _mergeData: function(record, data) {
        var merged = Object.assign({}, record);
        
        for (var prop in data) {
            var value = data[prop];

            if (typeof value == 'string' && value.indexOf('{{') != -1) {
                value = dmx.parse(value, new dmx.DataScope(record, this));
            }

            merged[prop] = value;
        }

        return merged;
    },

    _insert: function(data) {
        var result = { inserted: [], deleted: [] };

        if (Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                var record = this._mergeData({ $id: ++this.lastid }, data[i]);
                this.records.push(record);
                result.inserted.push(record);
            }
        } else {
            var record = this._mergeData({ $id: ++this.lastid }, data);
            this.records.push(record);
            result.inserted.push(record);
        }

        this.dispatchEvent('inserted', null, result);
    },

    _update: function(filter, data) {
        if (!this._parseData(data)) {
            console.warn('Invalid data!', data);
            return;
        }

        var result = { inserted: [], deleted: [] };
        
        this._filter(filter).forEach(function(record) {
            var newRecord = this._mergeData(record, data);
            if (!dmx.equal(record, newRecord)) {
                result.deleted.push(dmx.clone(record));
                result.inserted.push(dmx.clone(newRecord));
                Object.assign(record, newRecord);
            }
        }, this);

        this.dispatchEvent('updated', null, result);
    },

    _delete: function(filter) {
        if (typeof filter == 'number') filter = { $id: filter };

        var result = { inserted: [], deleted: [] };

        this.records = this.records.filter(function(record) {
            for (var prop in filter) {
                if (record[prop] === filter[prop]) {
                    result.deleted.push(dmx.clone(record));
                    return false;
                }
            }

            return true;
        });

        this.dispatchEvent('deleted', null, result);
    },

    _store: function() {
        var data = JSON.stringify({
            records: this.records,
            lastid: this.lastid
        });

        if (data !== this.store.getItem('datastore_' + this.name)) {
            this.store.setItem('datastore_' + this.name, data);
            //this.set('data', dmx.clone(this.records));
            this._setData();
        }
    },

    _setData: function() {
        var data = dmx.clone(this.records);

        if (typeof this.props.columns == 'object') {
            for (var i in data) {
                var record = data[i];
                var scope = new dmx.DataScope(Object.assign({
                    $value: record,
                    $index: i,
                    $key: i
                }, record), this);

                for (var column in this.props.columns) {
                    record[column] = dmx.parse(this.props.columns[column], scope);
                }
            }
        }

        this.set('data', data);
    }

});
